import React, { useCallback, useEffect, useState } from "react";
import { toggleChatbot } from "~/utils/chatbot";
import { useAuth } from "../hooks/auth";
import CryptoJS from "crypto-js";
import styled from "styled-components";

export const ChatButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #d31f2e;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: ${(props) => (props.chatActive ? "flex" : "none")};
  align-items: center;
  gap: 8px;
  font-size: 16px;
  z-index: 9999;
  transition: background-color 0.3s, transform 0.2s;

  &:hover {
    background-color: #b91b27;
  }

  &:active {
    transform: scale(0.95);
  }

  .chat-icon {
    font-size: 20px;
  }
`;

export const ChatWindow = styled.iframe`
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 400px;
  height: 600px;
  border: none;
  background-color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  overflow: hidden;
  display: ${(props) => (props.chatActive ? "block" : "none")};
  z-index: 9998;

  @media (max-width: 500px) {
    width: 90%;
    right: 5%;
    height: 80%;
  }
`;

export default function SmartNXChat() {
  const { isLogged } = useAuth();
  const [chatActive, setChatActive] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [src, setSrc] = useState("");

  const fetchChatBot = useCallback(async () => {
    if (chatActive) {
      setChatActive(false);
      return;
    }
    if (!isAuthenticated) {
      const keyId = process.env.REACT_APP_SMART_NX_KEY_ID;
      const keySecret = process.env.REACT_APP_SMART_NX_KEY_SECRET;
      const response = await fetch(
        "https://api-nxsuite.smartnx.io/webchat-plus-sbc/authentication",
        {
          method: "POST",
          body: JSON.stringify({
            keyId,
            keySecret,
          }),
          headers: {
            "Content-type": "application/json",
          },
        }
      );

      if (response.ok) {
        const user = JSON.parse(localStorage.getItem("@NovaEra:infoUsuario"));
        const celular = localStorage.getItem("@NovaEra:celularCliente");
        const res = await response.json();
        const nomeEncrypt = CryptoJS.AES.encrypt(
          user?.nome,
          keySecret
        ).toString();
        const telefoneEncrypt = CryptoJS.AES.encrypt(
          celular || "",
          keySecret
        ).toString();
        const emailEncrypt = CryptoJS.AES.encrypt(
          user?.email,
          keySecret
        ).toString();
        const cpfEncrypt = CryptoJS.AES.encrypt(
          user?.cpf,
          keySecret
        ).toString();

        const paramNome = encodeURIComponent(nomeEncrypt);
        const paramTelefone = encodeURIComponent(telefoneEncrypt);
        const paramEmail = encodeURIComponent(emailEncrypt);
        const paramCpf = encodeURIComponent(cpfEncrypt);
        const url = `https://master.d3cf1mgex5k4u4.amplifyapp.com?token=${res.token}&nome=${paramNome}&cpf_cnpj=${paramCpf}&telefone=${paramTelefone}&e_mail=${paramEmail}`;
        setSrc(url);
        setIsAuthenticated(true);
        setChatActive(true);
        return;
      }
    }
    setChatActive(true);
  }, [chatActive, isAuthenticated]);

  return (
    <>
      <ChatButton
        chatActive={isLogged}
        onClick={fetchChatBot}
        id="chat-button"
        className="chat-button"
        title="Fale conosco"
      >
        <span className="chat-icon" role="img" aria-label="baloon">
          💬
        </span>
        <span>Atendimento Online</span>
      </ChatButton>

      <ChatWindow
        src={src}
        chatActive={chatActive && isLogged}
        title="chat-window"
        id="chatFrame"
        className="chat-window"
      ></ChatWindow>
    </>
  );
}
